"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@linaria/core");
"c1yz6tml";
const cardMediaStyle = "c10y9xud";
var _default = exports.default = cardMediaStyle;